module.exports = __webpack_public_path__ + "static/media/snapchat.1fd8d27c.svg";